import { NodeModel } from "../_model/NodeModel";
import { DecorationUltrafiltro } from "./decorationUltrafiltro"
import { Types } from "../../utils/nodeTypes"
import Properties from "../_model/ModelEngineeringProperties";


class Ultrafiltro extends NodeModel {
  constructor() {
    super("Ultrafiltro");
    
    this.type = new Types().Ultrafiltro;
    this.x = 0;
    this.y = 0;
    this.height = 90;
    this.width = 90;
    this.xImg = () => this.x + 2;
    this.yImg = () => this.y + 2;    
    this.srcImg = require("@/assets/Fluxogramas/ultrafiltro.png");
    this.data = [new Properties({...this })];
    
    this.decorate = async function(callback) {
      this.decorator = new DecorationUltrafiltro();
      await this.decorator.init(this,callback)
    };

    /* Métodos para serem implementados */ 

    this.clone = () => {
      let cloned = new Ultrafiltro()
      cloned.id = this.id;
      cloned.idName = this.idName;
      cloned.type = this.type
      cloned.x = this.x
      cloned.y = this.y
      cloned.height = this.height
      cloned.width = this.width
      cloned.decorator = null
      cloned.readOnly = this.readOnly;
			cloned.expressionVisible = this.expressionVisible;
      cloned.data = this.data.map(d => d.clone())
      return cloned
    }

    this.copyFrom = (node) => {
      this.simpleCopyFrom(node);
      this.data = node.data.map(d => new Properties({...d }));
    }


  }
}

export { Ultrafiltro };
